import { animate, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { IndicadoresAtividadeService } from '../../services/indicadores-atividade.service';
import { IndicadoresProjetoService } from '../../services/indicadores-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ClonarModalComponent } from '../clonar-modal/clonar-modal.component';
import { StorageService } from 'src/app/shared/services/storage.service';

@Component({
  selector: 'app-detalhe-projeto-indicadores-list',
  templateUrl: './detalhe-projeto-indicadores-list.component.html',
  styleUrls: ['./detalhe-projeto-indicadores-list.component.scss'],
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-50%)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0, transform: 'translateX(-50%)' }))
      ])
    ])
  ]
})
export class DetalheProjetoIndicadoresListComponent extends BaseListComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  indicadoresList: IndicadoresProjeto[];
  ordenacao: boolean;
  filters: any;
  form: FormGroup;
  simNaoList: any[] = [
    { id: "0", label: "Não" },
    { id: "1", label: "Sim" },
  ];
  permission: any;
  filterActive: boolean = false;
  dragAndDropActive: boolean = false;
  filterIndId: string = '';

  @ViewChild("clonarModal") clonarModal: ClonarModalComponent;
  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(private myService: IndicadoresProjetoService,
    private atividadeService: IndicadoresAtividadeService,
    public activatedRoute: ActivatedRoute,
    private pesquisaGeralService: PesquisaGeralService,
    private storage: StorageService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.filterIndId = 'filterIndValue_' + this.idProjeto;
      let filterValue = this.storage.getFilterValue(this.filterIndId);

      this.addSub(
        this.myService.getFilters(this.idProjeto).subscribe((res) => {
          this.filters = res;
        if (filterValue) {
          this.filterActive = true;
          this.form.patchValue(filterValue);
        } else {
          this.form.get('indicator_year').setValue(this.filters?.ano_check ? [this.filters?.ano_check] : null);
        }
          this.initList(this.form?.value);
        })
      )
      this.initForm();
    });

    this.addSub(EventSharedService.get('loading').subscribe(() => {
      this.loading();
    }))
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initForm() {
    this.form = new FormGroup({
      indicator_year: new FormControl(null),
      indicator_level_label_id: new FormControl(null),
      indicator_irfe_enabled_id: new FormControl(null),
    });
  }

  initList(obj = null) {
    this.addSub(
      this.myService.getList(this.idProjeto, obj).subscribe({
        next: (res) => {
          this.indicadoresList = res['list'];
          this.permission = res['permission'];
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  drop(event: CdkDragDrop<string[]>) {
    this.ordenacao = true;
    moveItemInArray(this.indicadoresList, event.previousIndex, event.currentIndex);
    this.indicadoresList.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
  }

  novo() {
    return ['/projetos', 'projeto', this.idProjeto, 'indicadores', 'adicionar'];
  }

  getDataCreateOrder(): any {
    return {
      pf_ind_order: this.indicadoresList.map((item) => {
        return { id: item.id, nro_ord: item.nro_ord };
      })
    }
  }

  salvarOrdem() {
    this.loading();
    this.ordenacao = false;

    this.addSub(
      this.myService.salvarOrdem(this.getDataCreateOrder()).subscribe({
        next: (res) => {
          this.msgSuccess("Ordem Salva com Sucesso!");
          this.loaded();
        },
        error: (err) => {
          this.msgError(err?.error?.message);
          this.loaded();
        },
      })
    )
  }

  cleanSearch() {
    this.storage.removeFilterValue(this.filterIndId);
    this.form.reset();
  }

  search() {
    this.loading();
    if (!Object.values(this.form?.value).every(value => value === null)) {
      this.storage.setFilterValue(this.filterIndId, this.form?.value);
    } else {
      this.storage.removeFilterValue(this.filterIndId);
    }
    this.initList(this.form?.value);
  }

  viewIndicador(id: number) {
    return ['/projetos', 'projeto', this.idProjeto, 'indicadores', id];
  }

  clonar(id: number) {
    this.clonarModal.openModal(id, "indicadores", true);
  }

  viewResonsavel(indicador: IndicadoresProjeto) {
    this.modalResonsavel.openModal([indicador, ...indicador?.resp_adj]);
  }

  viewInfo(indicador: IndicadoresProjeto) {
    if (indicador?.viewInfoActive) {
      indicador.viewInfoActive = false;
      return;
    }

    this.loading();
    this.addSub(
      this.atividadeService.getListAll(indicador?.id).subscribe({
        next: (res) => {
          if (res['actions']?.length) {
            indicador.action = res['actions'];
          }
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    );

    this.myService.graphTable(indicador?.id).subscribe({
      next: (value) => {
        if (value) {
          indicador.chartOptions = {
            responsive: true,
          };
          indicador.chartLabels = [];
          indicador.chartData;
          indicador.chartType = value?.type_graph == 2 ? 'line' : 'bar';
          indicador.chartMeta = [];
          indicador.chartRealizado = [];

          value.itens.forEach((item, index) => {
            if (index != 0) {
              indicador.chartLabels.push(item[0]);
              indicador.chartMeta.push(item[1]);
              indicador.chartRealizado.push(item[2]);
            }
          })

          indicador.chartData = {
            labels: indicador.chartLabels,
            datasets: [
              {
                data: indicador.chartMeta,
                label: value.itens[0][1],
                pointRadius: 5,
              },
              {
                data: indicador.chartRealizado,
                label: value.itens[0][2],
                pointRadius: 5,
              },
            ],
          };
        }
        indicador.viewInfoActive = true;
        this.loaded();
      },
      error: (err) => {
        indicador.viewInfoActive = true;
        this.msgError(err?.error?.message);
        this.loaded();
      },
    })
  }
}
